import { ViewController, TextView } from "@gaming/srvg-classes-core";
import { PhaseChangeEvent } from "../../Event/PhaseChangeEvent";

export class MatchdayTextViewController extends ViewController {
    name: string;
    textView: TextView;

    constructor( options ) {
        options = options || {};
        options.view = options.textView || null;
        super( options );
        this.name = 'matchdayTextViewController';
        this.textView = options.textView ||null;
    }

    handlePhaseChangeEvent( event: PhaseChangeEvent, provider ) {
        this.textView.setText( __('Matchday') + ' ' + event.matchday.nr );
    }
}